import React from "react";

import ExactMatch from "./exact_match";
import Regex from "./regex";
import ApplicableClauses from "./applicable_clauses";

import {Test} from "common/flowmaster/types/test";

const components = {
  exact_match: ExactMatch,
  regex: Regex,
  applicable_clauses: ApplicableClauses,
};

type Props = {
  test: Test;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestEditor({test, onChange}: Props) {
  const Component = components[test.test_type];
  return <Component value={test.value} onChange={onChange} />;
}
